import {onFind} from "@elements/init-modules-in-scope";

export function init() {
    onFind('.main-navbar__main.js-affix', (baseElement) => {
        setHeaderHeightVariable(baseElement)

        window.addEventListener('resize', () => {
            setHeaderHeightVariable(baseElement)
        });
    })
}

const setHeaderHeightVariable = (header) => {
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
}